import type { Brand, Model } from '@studio/models/device';
import type { T_Maybe, T_Optional } from '@tryiris-ai/js-types';
import type { Selection } from './types.js';
import type { Collection } from '#~/api/device/registry/index.js';
import type { Template } from '#~/device/registry/index.js';
import { getNickname } from '#~/device/registry/index.js';

/** @internal */
export const getDefaultName = ({
  brands,
  models,
  selection
}: T_Optional<{
  brands: Collection<Brand>;
  models: Collection<Model>;
  selection: Selection;
}>): T_Maybe<string> => {
  const brand = selection?.brandId ? brands?.items[selection.brandId] : undefined;
  const model = selection?.modelId ? models?.items[selection.modelId] : undefined;

  return brand && model ? getNickname(brand, model) : undefined;
};

/** @internal */
export const getInitialSelection = (config?: Template): Selection =>
  config ? { brandId: config.model.brandId, modelId: config.model.id } : {};
